import React from 'react';
import { FormProps } from 'util/Form';
import DateFormItem from 'components/shared/DateFormItem';

interface DateQuestionFormItemProps extends FormProps {
  fieldName: string;
  required?: boolean;
}

const DateQuestionFormItem: React.FunctionComponent<DateQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
}) => {
  return <DateFormItem fieldName={fieldName} required={required} disabled={disabled} />;
};
export default DateQuestionFormItem;
